function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#chevron-right_svg__clip0_3372_6285)"
}, React.createElement("path", {
  d: "M11.26 10.274l6.107 6.12-6.107 6.12 1.88 1.88 8-8-8-8-1.88 1.88z",
  fill: "#fff"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "chevron-right_svg__clip0_3372_6285"
}, React.createElement("path", {
  fill: "#fff",
  transform: "translate(.2)",
  d: "M0 0h32v32H0z"
})));

var SvgChevronRight = function SvgChevronRight(props) {
  return React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cg clip-path='url(%23clip0_3372_6285)'%3E %3Cpath d='M11.2603 10.2736L17.3669 16.3936L11.2603 22.5136L13.1403 24.3936L21.1403 16.3936L13.1403 8.39355L11.2603 10.2736Z' fill='white'/%3E %3C/g%3E %3Cdefs%3E %3CclipPath id='clip0_3372_6285'%3E %3Crect width='32' height='32' fill='white' transform='translate(0.200195)'/%3E %3C/clipPath%3E %3C/defs%3E %3C/svg%3E";
export { SvgChevronRight as ReactComponent };